import { create } from "zustand";
import { createApiClient } from "@/lib/api/client";

export interface ModelTimingStat {
  p50_s: number;
  samples: number;
}

const STALE_MS = 60_000; // re-fetch at most once per minute

interface TimingStatsStore {
  stats: Record<string, ModelTimingStat>;
  _fetchedAt: number | null;
  fetch: (getToken: () => Promise<string | null>) => Promise<void>;
}

export const useTimingStatsStore = create<TimingStatsStore>((set, get) => ({
  stats: {},
  _fetchedAt: null,

  fetch: async (getToken) => {
    const now = Date.now();
    const fetchedAt = get()._fetchedAt;
    if (fetchedAt !== null && now - fetchedAt < STALE_MS) return;
    try {
      const api = createApiClient({ getToken });
      const data = await api.get<Record<string, ModelTimingStat>>(
        "/api/metrics/timing-stats"
      );
      set({ stats: data, _fetchedAt: now });
    } catch {
      // Non-fatal — percentage just won't show
    }
  },
}));
